import {createFileRoute} from "@tanstack/react-router";
import {z as zod} from "zod";
import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {reportMetadataZodValidator, type ReportMetadata} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/Report";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/reports",
)({
    loader: async ({context}) => {
        const authorizedReportsResult = await robustJsonResultClientFetch<Array<ReportMetadata>>(
            `${context.intellsysBaseUrl}/sub-system/pluto/reports/get`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${context.authenticationStatus.accessToken}`,
                    "X-Workspace-Id": context.workspace.id,
                },
                body: JSON.stringify({}),
            },
            zod.array(reportMetadataZodValidator),
        );
        if (authorizedReportsResult.success === false) {
            throw authorizedReportsResult.error;
        }
        const authorizedReports = authorizedReportsResult.data;

        return {
            workspace: context.workspace,
            authorizedReports,
            datasetLogoMap: null,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
